"use strict";var t=require("styled-components");const o=t.keyframes`
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
`,e=t.keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`,r=t.keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`;exports.FadeInAnimation=e,exports.FadeOutAnimation=r,exports.LoadingAnimation=o;



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/loaders/cjs/components/LoaderAnimations.js
// module id = 518
// module chunks = 0